import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/images/productİcon.png");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/images/products.jpg");
